import ModelState, {localised} from './_util/model';

@localised
class SpecialitiesState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get url() { return '/specialities'; }
  get singular() { return 'speciality'; }
  get plural() { return 'specialities'; }

  get defaultQuery() {
    if (this.ctx.address && this.ctx.address.response && this.ctx.address.response.city) {
      return `city=${this.ctx.address.response.city.id}`;
    }

    return null;
  }
}

export default SpecialitiesState;



// WEBPACK FOOTER //
// ./spa/state/specialities.jsx